import { Info, TrendingUp, Activity, Gauge, Waves, BarChart3, LineChart } from "lucide-react";

const ITEMS = [
  { icon: LineChart, label: "EMA 20" },
  { icon: TrendingUp, label: "EMA 200" },
  { icon: Activity, label: "RSI 14" },
  { icon: Gauge, label: "CCI 20" },
  { icon: Waves, label: "Bollinger Bands 20/2" },
  { icon: BarChart3, label: "Volume" },
];

export default function RecommendedIndicators() {
  return (
    <div data-testid="recommended-indicators-card" className="rounded-2xl border p-5 sm:p-6"
      style={{ background: "var(--bg-card)", borderColor: "var(--border-subtle)" }}>
      <div className="flex items-center gap-2 mb-4">
        <Info className="w-5 h-5 text-blue-500" />
        <h3 className="text-base font-bold tracking-tight">📊 Daha Sağlıklı Analiz İçin Önerilen İndikatörler</h3>
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-3 gap-2.5">
        {ITEMS.map(({ icon: Icon, label }) => (
          <div key={label} className="flex items-center gap-2 rounded-xl border px-3 py-2.5 text-sm"
            style={{ background: "var(--bg-main)", borderColor: "var(--border-subtle)" }}>
            <Icon className="w-4 h-4 text-blue-500 shrink-0" />
            <span className="font-medium">{label}</span>
          </div>
        ))}
      </div>
      <p className="text-xs mt-4 leading-relaxed" style={{ color: "var(--text-muted)" }}>
        Bu indikatörlerin kullanılması <span className="font-semibold">zorunlu değildir</span>. Mevcut grafik
        ekran görüntünüzü doğrudan yükleyebilirsiniz. Sistem yalnızca görüntüde bulunan teknik verileri analiz eder.
      </p>
    </div>
  );
}
